@if (product.pricing != null) {
	<div class="price-adjustments-details">
		<div class="price-factors-part">
			@if (!is27x01Standard()) {
				<div class="label">
					<span>{{ label | async }}</span>
					<change-label [visible]="isRiskChanged()" [changeSet]="changeSet"></change-label>
				</div>
				<div class="label-value">
					{{ risk | riskName: gender | async }}
				</div>
				@if (isIso14001or45001() && isRva() && isEmployeeLogged()) {
					<br>
					<div class="label">
						<span>{{ riskLabel | async }}</span>
						<change-label [visible]="isRiskChanged()" [changeSet]="changeSet"></change-label>
					</div>
					<div class="label-value">
						{{ complexityFactor | riskName: gender | async }}
					</div>
				}
			}
			@if (is27x01Standard()) {
				<div class="label">
					<span>{{ 'pricing-details.factors-considered' | translate }}</span>
				</div>
				@if (!isRva()) {
					<div class="label-value">
						{{ 'pricing-details.effort-to-audit' | translate }}: {{ auditEffort | effortName: "male" }}
						<change-label [visible]="isAuditEffortChanged()" [changeSet]="changeSet"></change-label>
					</div>
				}
				<div class="label-value">
					{{ 'pricing-details.business-complexity' | translate }}: {{ businessComplexity | effortName: "female" }}
					<change-label [visible]="isBusinessComplexityChanged()" [changeSet]="changeSet"></change-label>
				</div>
				<div class="label-value">
					@if (product.standard.name == 'ISO_27001') {
						<span>{{ 'pricing-details.it-complexity' | translate }}: {{ itComplexity | effortName: "female" }}</span>
					}
					@if (product.standard.name == 'ISO_27701') {
						<span>{{ 'pricing-details.private-info' | translate }}: {{ itComplexity | effortName: "female" }}</span>
					}
					<change-label [visible]="isItComplexityChanged()" [changeSet]="changeSet"></change-label>
				</div>
			}
		</div>
		@if (showDailyRate) {
			<div class="daily-rate-part">
				<div class="label">
					<span>DAILY RATE</span>
					<change-label [visible]="isDailyRateChanged()" [changeSet]="changeSet"/>
				</div>

				@if (showDailyRateModal) {
					<span class="label-value clickable-label" (click)="openDailyRateModal(dailyRateDialog)">varies per audit event</span>
				} @else {
					<div class="label-value">
						{{ getTotalDailyRate() | price | async }}
					</div>
				}
			</div>
		}
	</div>
}

<ng-template #dailyRateDialog let-dialogRef="dialogRef">
	<nb-card class="daily-rate-dialog">
		<nb-card-header class="daily-rates-header">DAILY RATE</nb-card-header>
		<nb-card-body>
			<div *ngFor="let fee of feesToShow" class="fee-row">
				<span class="fee-name">{{ ('pricing-details.fees.' + fee.type.toLowerCase()) | translate }}</span>
				<span class="fee-amount">{{ fee.amount | price | async }}</span>
			</div>
		</nb-card-body>
		<nb-card-footer>
			<button nbButton outline status="success" size="small" (click)="dialogRef.close()">CLOSE</button>
		</nb-card-footer>
	</nb-card>
</ng-template>
